<div *ngIf="busy">Fetching data...</div>

<div *ngIf="!busy && scores.length == 0">
  No matches have been recorded yet.
</div>
<div *ngIf="!busy && scores.length > 0 " class="scores">
  <table class="table table-bordered">
    <thead>
      <tr>
        <td class="points">Points</td>
        <td>Player</td>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let score of scores" [ngClass]="{'bold':player.id==score.opponent.id,'bold':player.doublesId==score.opponent.id}">
        <td class="points">{{score.points}}</td>
        <td>
          <a [routerLink]="['/player',score.opponent.id]">
            {{score.opponent.name}}
          </a>
          <sup>{{score.rank}}</sup>
          &nbsp;
          <span style="font-size: 0.8em;">({{score.matchCount}})</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>